import { CurrencyPipe, DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import {APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule} from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatBadgeModule } from '@angular/material/badge';
import { Router } from '@angular/router';

import { CoreModule } from '../core/core.module';
import { ApiInterceptorService } from '../core/services/api-interceptor.service';
import { ApiHelper } from '../core/services/apiHelper';
import { ErrorSnackBarComponent, GlobalErrorHandler } from '../core/services/errorHandler/GlobalErrorHandler';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FourOhFourModule } from './four-oh-four/four-oh-four.module';
import { LoginModule } from './login/login.module';
import { ForgotPasswordModule } from './password/forgot-password/forgot-password.module';
import { ResetPasswordModule } from './password/reset-password/reset-password.module';
import { PortalModule } from './portal/portal.module';
import { PublicModule } from './public/public.module';
import { AppSnackComponent } from './shared/app-snack/app-snack.component';
import { AppMaterialModule } from './shared/appMaterial/app-material.module';
import { ErrorDialogModule } from './shared/errorDialog/errorDialog.module';
import { SharedModule } from './shared/shared.module';
import { NgxStripeModule } from 'ngx-stripe';
import {environment} from "../environments/environment";
import { MatRippleModule } from '@angular/material/core';



@NgModule({
    declarations: [AppComponent, AppSnackComponent, ErrorSnackBarComponent],
  imports: [
    SharedModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    AppMaterialModule,
    AppRoutingModule,
    LoginModule,
    ResetPasswordModule,
    ForgotPasswordModule,
    PortalModule,
    PublicModule,
    FourOhFourModule,
    HttpClientModule,
    CoreModule,
    ErrorDialogModule,
    FlexLayoutModule.withConfig({ useColumnBasisZero: false }),
    MatBadgeModule,
    NgxStripeModule.forRoot(environment.stripe_pk),
    MatRippleModule
  ],
    providers: [
        ApiHelper,
        { provide: ErrorHandler, useClass: GlobalErrorHandler },
        DatePipe,
        CurrencyPipe,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ApiInterceptorService,
            multi: true
        }
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {}
